import React from "react";
import { View, StyleSheet, ViewStyle, StyleProp } from "react-native";

export const TABLE_START_WIDTH = 45;
export const TABLE_START_WIDTH_SELECTABLE = 74;

export type TableStartProps = {
  selectable?: boolean;
  borderColor?: string;
  backgroundColor?: string;
  style?: StyleProp<ViewStyle>;
  children?: React.ReactNode;
};

export function TableStart({ selectable, borderColor, backgroundColor, style, children }: TableStartProps) {
  return (
    <View
      style={[
        styles.start,
        { borderColor, backgroundColor },
        { width: selectable ? TABLE_START_WIDTH_SELECTABLE : TABLE_START_WIDTH },
        style,
      ]}
    >
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  start: {
    height: "100%",
    flexDirection: "row",
    flexShrink: 0,
    justifyContent: "space-between",
    alignContent: "flex-start",
    alignItems: "center",
    gap: 8,
    padding: 8,
    borderRightWidth: 1,
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6,
  },
});
